import { createBrowserClient } from "@supabase/ssr"

let client: ReturnType<typeof createBrowserClient> | null = null

export function createClient() {
  if (!client) {
    client = createBrowserClient(
      process.env.NEXT_PUBLIC_SUPABASE_URL!,
      process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
      {
        auth: {
          flowType: "pkce",
          persistSession: true,
          detectSessionInUrl: true,
          // Custom lock function that executes immediately without navigator.locks
          // This prevents "Lock was stolen" errors when multiple components
          // call getUser()/getSession() concurrently
          lock: async (name: string, acquireTimeout: number, fn: () => Promise<unknown>) => {
            return await fn()
          },
        },
      }
    )
  }
  return client
}
